export default __webpack_public_path__ + "static/media/redUnfilledDot.850fbf2d.svg";